module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8ITl5"))).then(() => parcelRequire('4axHD'));